import Marionette from 'backbone.marionette';
import loadingView from '../templates/loading_view.tpl';
export default Marionette.ItemView.extend({
  template: loadingView,
  id: 'spinner'
});